<div class="not-found-page">
  <div class="not-found-content">
    <div class="error-code">404</div>
    <h1 class="error-title">Page Not Found</h1>
    <p class="error-desc">
      The page you're looking for doesn't exist or has been moved.
    </p>
    <div class="error-actions">
      <button class="btn-primary" (click)="goHome()">Go to Homepage</button>
      <button class="btn-outline" (click)="goBack()">Go Back</button>
    </div>
    <div class="error-brand">
      <img src="assets/reball/reball logo no bg.png" alt="ReBall" class="error-logo" />
      <span class="error-brand-text">ReBall</span>
    </div>
  </div>
</div>
